import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UsersComponent } from '../users/users.component';

import { ScoreboardComponent } from '../scoreboard/scoreboard.component';
import { QsleaderbaordComponent } from '../qsleaderbaord/qsleaderbaord.component';
import { QsrugbyComponent } from '../qsrugby/qsrugby.component';

import { ExpiredGuard } from '../guards/expired.guard';

const routes: Routes = [
  { path: '', redirectTo: '/users', pathMatch: 'full' },
  { path: 'users',  component: UsersComponent },
  { path: 'scoreboard/:id',  component:  ScoreboardComponent },
  { path: 'qsleaderbaord/:id/:params',  component:  QsleaderbaordComponent },
  { path: 'qsrugby/:id/:params',  component:  QsrugbyComponent},
  { path: 'cricket',
    loadChildren: '../cricket/cricket.module#CricketModule'
  }
];


@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers: [
    ExpiredGuard
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts